/**
 * Basic Terms Section - Sections 1-4: Acceptance, Registration, Use, Restrictions
 */

import React from 'react';

export const BasicTermsSection: React.FC = () => (
  <>
    <section>
      <h2 className="text-xl font-semibold mb-3">1. Acceptance of Terms</h2>
      <p className="text-gray-600">
        By creating an account or using DinnerBrain, you agree to these Terms and our Privacy Policy. 
        If you do not agree to these Terms, please do not use our Service.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold mb-3">2. Account Registration</h2>
      <div className="space-y-2 text-gray-600">
        <p>To use certain features of the Service, you must register for an account. You agree to:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Provide accurate and complete information</li>
          <li>Maintain the security of your password</li>
          <li>Notify us immediately of any unauthorized use</li>
          <li>Be responsible for all activities under your account</li>
        </ul>
      </div>
    </section>

    <section>
      <h2 className="text-xl font-semibold mb-3">3. Use of Service</h2>
      <div className="space-y-3 text-gray-600">
        <p className="font-semibold text-gray-700">You may use DinnerBrain to:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Store and organize personal recipes</li>
          <li>Create meal plans and shopping lists</li>
          <li>Share recipes with others</li>
          <li>Import and export recipe data</li>
        </ul>
        
        <p className="font-semibold text-gray-700 mt-4">You agree NOT to:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Use the Service for any illegal purpose</li>
          <li>Upload malicious code or harmful content</li>
          <li>Attempt to gain unauthorized access to the Service</li>
          <li>Interfere with or disrupt the Service</li>
          <li>Copy or scrape content without permission</li>
          <li>Violate any applicable laws or regulations</li>
        </ul>
      </div>
    </section>
  </>
);